import { render, staticRenderFns } from "./ConsultaNotaFiscal.vue?vue&type=template&id=1a224148"
import script from "./ConsultaNotaFiscal.vue?vue&type=script&lang=js"
export * from "./ConsultaNotaFiscal.vue?vue&type=script&lang=js"
import style0 from "./ConsultaNotaFiscal.vue?vue&type=style&index=0&id=1a224148&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports